import { useProjectId } from "../../shopdrawing/ProjectName";
import { QuoteSwitcher } from "../pricing/QuoteSwitcher";
import { jsx as _jsx } from "react/jsx-runtime";
export function MiscSwitcher() { const projectId = useProjectId(); return /*#__PURE__*/ _jsx(QuoteSwitcher, { title: "Misc", url: `/project/${projectId}/shop-drawing/misc`, quoteTitle: "Quote Misc", quoteURL: `/project/${projectId}/quote/-1/misc` }); }
